'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KODIV_CN = 'a-keyboard-hover-only-div';

///a duv only shows outline when keyboard focus
// no outline when mouse focus

var KODIV = function (_React$Component) {
  _inherits(KODIV, _React$Component);

  function KODIV(props) {
    _classCallCheck(this, KODIV);

    var _this = _possibleConstructorReturn(this, (KODIV.__proto__ || Object.getPrototypeOf(KODIV)).call(this, props));

    _this.onMouseDown = function (event) {
      _this.setState({
        allowOutline: false
      });

      var onMouseDown = _this.props.onMouseDown;

      onMouseDown && onMouseDown(event);
    };

    _this.onBlur = function (event) {
      if (_this.cancelBlurOnce) {
        _this.cancelBlurOnce = false;
        return;
      }

      _this.setState({
        allowOutline: true
      });

      var onBlur = _this.props.onBlur;

      onBlur && onBlur(event);
    };

    _this.onDragEnter = function (event) {
      if (!_this.props.dragable) {
        return;
      }

      _this.setState({
        allowOutline: true,
        inDrag: true
      });

      _this.props.onDragEnter && _this.props.onDragEnter(event);
    };

    _this.onDragLeave = function (event) {
      if (!_this.props.dragable) {
        return;
      }

      event.preventDefault();

      var dom = _reactDom2.default.findDOMNode(_this.dom);
      var container = dom.getClientRects();
      if (!container[0]) {
        return;
      }
      var _container$ = container[0],
          left = _container$.left,
          right = _container$.right,
          top = _container$.top,
          bottom = _container$.bottom;


      var x = event.clientX;
      var y = event.clientY;

      if (x <= left || x >= right || y <= top || y >= bottom) {
        _this.setState({
          allowOutline: false,
          inDrag: false
        });
      }

      _this.props.onDragLeave && _this.props.onDragLeave(event);
    };

    _this.onDrop = function () {
      if (!_this.props.dragable) {
        return;
      }

      _this.setState({
        allowOutline: false,
        inDrag: false
      });
    };

    _this.onKeyDownDefault = function (event) {
      if (_this.props.isButton) {
        return;
      }
      if (event.key === "Enter") {
        var dom = _reactDom2.default.findDOMNode(_this.dom);
        dom.click();
      }
    };

    _this.state = {
      allowOutline: true
    };
    return _this;
  }

  //hacking for upload open file dialog


  _createClass(KODIV, [{
    key: 'disableOutlineForFileDialog',
    value: function disableOutlineForFileDialog() {
      this.setState({
        allowOutline: false
      });
      this.cancelBlurOnce = true;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          className = _props.className,
          children = _props.children,
          isSpan = _props.isSpan,
          isButton = _props.isButton,
          tabIndex = _props.tabIndex,
          dragable = _props.dragable,
          isLi = _props.isLi,
          isLoading = _props.isLoading,
          isLoadingBlocking = _props.isLoadingBlocking,
          onClick = _props.onClick,
          onMouseDown = _props.onMouseDown,
          onBlur = _props.onBlur,
          onDragEnter = _props.onDragEnter,
          onDragLeave = _props.onDragLeave,
          onDrop = _props.onDrop,
          onKeyDown = _props.onKeyDown,
          others = _objectWithoutProperties(_props, ['className', 'children', 'isSpan', 'isButton', 'tabIndex', 'dragable', 'isLi', 'isLoading', 'isLoadingBlocking', 'onClick', 'onMouseDown', 'onBlur', 'onDragEnter', 'onDragLeave', 'onDrop', 'onKeyDown']);

      var classNames = (0, _classnames2.default)(className, KODIV_CN, {
        "a-no-outline-click": !this.state.allowOutline,
        "in-drag": this.state.allowOutline && this.state.inDrag
      });

      var commonProps = {
        tabIndex: tabIndex || 0,
        className: classNames,
        onClick: onClick || function () {},
        onMouseDown: this.onMouseDown,
        onBlur: this.onBlur,
        onDragEnter: this.onDragEnter,
        onDragLeave: this.onDragLeave,
        onDrop: this.onDrop,
        onKeyDown: onKeyDown || this.onKeyDownDefault,
        ref: function ref(_ref) {
          return _this2.dom = _ref;
        }
      };

      if (isLi) {
        return React.createElement(
          'li',
          Object.assign({}, commonProps, others),
          children
        );
      } else if (isButton) {
        if (this.props.isLoading && this.props.isLoadingBlocking) {
          commonProps.onClick = function () {};
        }

        return React.createElement(
          'button',
          Object.assign({ type: 'button'
          }, commonProps, others),
          children
        );
      } else if (isSpan) {
        return React.createElement(
          'span',
          Object.assign({}, commonProps, others),
          children
        );
      } else {
        return React.createElement(
          'div',
          Object.assign({}, commonProps, others),
          children
        );
      }
    }
  }]);

  return KODIV;
}(React.Component);

KODIV.propTypes = {
  isSpan: _propTypes2.default.bool,
  isButton: _propTypes2.default.bool,
  isLi: _propTypes2.default.bool,
  dragable: _propTypes2.default.bool
};

KODIV.displayName = 'KODIV';

exports.default = KODIV;